/**
 * This function returns a promise that resolves with a websocket connection to the provided URL
 */

export const getWebsocketConnection = websocketUrl => {
  let protocols;
  if (process.env.NODE_ENV !== 'production') {
    const token = localStorage.getItem('token')?.slice?.(1, -1);
    const orgId = localStorage.getItem('orgID');
    const headers = {
      'x-cap-api-auth-org-id': orgId,
      Authorization: 'Bearer ' + token,
    };
    const headersEncoded = encodeURIComponent(JSON.stringify(headers));
    protocols = ['basic', headersEncoded];
  }
  return new Promise((resolve, reject) => {
    const socket = new WebSocket(websocketUrl, protocols);
    const heartbeat = () => {
      if (socket.readyState === WebSocket.OPEN) {
        socket.send('ping');
      }
    };
    socket.onopen = () => {
      setInterval(heartbeat, 20000);
      resolve(socket);
    };
    socket.onerror = reject;
    socket.onclose = () => {
      clearInterval(heartbeat);
    };
  });
};

export const getAnchoredPopupPosition = (
  pivotRef,
  titleBarPadding,
  popupWidth,
  popupHeight,
) => {
  const rect = pivotRef.current?.getBoundingClientRect();
  return {
    left: `min(calc(${
      rect.x
    }px - ${titleBarPadding}), calc(100vw - ${popupWidth}))`,
    top: `min(calc(${
      rect.y
    }px - ${titleBarPadding}), calc(100vh - ${popupHeight}))`,
  };
};

export const getBottomRightPopupPosition = (popupWidth, popupHeight, gap) => {
  return {
    bottom: gap,
    right: gap,
  };
};

export const handleEmptyValue = value => (value ? value : '-');

export const getFullNameByFirstNameLastName = ({
  firstName,
  lastName,
  fetchNameIntitialCharacters,
}) => {
  if (!firstName && !lastName) {
    return '';
  }
  const firstNameInitial = firstName?.charAt(0)?.toUpperCase();
  const lastNameInitial = lastName?.charAt(0)?.toUpperCase();
  if (!firstName) {
    return handleEmptyValue(
      fetchNameIntitialCharacters ? lastNameInitial : lastName,
    );
  }
  if (!lastName) {
    return handleEmptyValue(
      fetchNameIntitialCharacters ? firstNameInitial : firstName,
    );
  }
  const fullName = `${firstName} ${lastName}`;
  const fetchNameIntitialFullCharacters = `${firstNameInitial}${lastNameInitial}`;
  return handleEmptyValue(
    fetchNameIntitialCharacters ? fetchNameIntitialFullCharacters : fullName,
  );
};
